module.exports = __webpack_public_path__ + "img/12312.47a8575.png";